/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from 'react';
import { FunctionComponent } from 'react';

import { useDispatch } from 'react-redux';
import { closeDialog, openDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { pageStateSelectors } from '../../../app/page/page-state/page-state.selectors';
import { updateMeeting } from '../../../app/page/page-storage/meetingsOld/meetings.actions';
import { IMeeting, IMeetingNewCreateForm } from '../../../app/resource/meeting/meeting.types';

import { useSelectWithParams } from '../../../utils/selector.utils';

import { SubmitButton } from '../../pages/common/forms/SubmitButton';

import { ConnectedDialog } from '../ConnectedDialog';
import { MeetingAgenda } from './MeetingAgenda';
import { IAgendaFormDialogProps } from './types';

export const AgendaFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const [isFormModified, setIsFormModified] = useState(false);

  const props = useSelectWithParams(dialogSelectors.selectDialogProps, 'agendaFormDialog') as IAgendaFormDialogProps;
  const isDialogOpen = useSelectWithParams(dialogSelectors.selectIsDialogOpen, 'agendaFormDialog');

  useEffect(() => {
    // Reset state when open the dialog
    if (isDialogOpen) {
      setIsFormModified(false);
    }
  }, [isDialogOpen]);

  const handleModify = () => {
    setIsFormModified(true);
  };

  const onClose = useCallback(() => {
    if (!isFormModified) {
      // If the agendaItem is nost modified, close
      return dispatch(closeDialog('agendaFormDialog'));
    }

    dispatch(
      openDialog('confirmation', {
        title: 'Are you sure you want to exit?',
        message: 'The changes you made will not be saved.',
        onConfirm: () => {
          dispatch(closeDialog('confirmation'));
          dispatch(closeDialog('agendaFormDialog'));
        },
        onDeny: () => dispatch(closeDialog('confirmation')),
        styles: { zIndex: '999999999', position: 'fixed' },
      }),
    );
  }, [dispatch, isFormModified]);

  const onSubmit = useCallback(
    (data: IMeetingNewCreateForm, meetingId: IMeeting['id']) => {
      dispatch(updateMeeting(meetingId, data));
    },
    [dispatch],
  );
  const showLoader = useSelectWithParams(pageStateSelectors.selectPageInProgress, 'meetingDashboard');

  return (
    <ConnectedDialog dialogKey="agendaFormDialog">
      <div className="popup new_board_popup" style={{ display: 'block' }}>
        <div className="panel" style={{ minWidth: '750px' }}>
          <div className="panel-header small-header flex jcsb">
            <h3>Agenda</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          {!showLoader && (
            <div className="panel-body">
              {props && props.meetingId && (
                <MeetingAgenda meetingId={props.meetingId} onFormModify={handleModify} onSubmit={onSubmit} />
              )}
            </div>
          )}
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>

            <SubmitButton apiKey="saveAgendaItemsApi" formName="meeting-form" text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
